<template>
  <div>
    <!-- :table-data="tableData" -->
    <task-optimizations-table
      :title="$t('global.routes.opticheck.optimizations')"
      :fields-info="filteredTableFields"
      :details-loader="detailsLoader"
      :table-data="this.childrenList(this.filteredTableFields, [], 'id', this.childItemName, 'active')"
      delete-mode="hard"
      :mainFilter="false"
      :fieldFilters="false"
      :list-records="listRecords"
      :get-record="getRecord"
      :create-record="createRecord"
      :update-record="updateRecord"
      :delete-record="deleteRecord"
      :resolverType="resolverType"
    ></task-optimizations-table>
    <task-optimization-details
      :details="details"
      :fields-info="fileteredDetailsFields"
    ></task-optimization-details>
  </div>
</template>

<script>
import FieldsInfoMixin from '../../optimizations/mixins/fields'
import LocalesMixin from '../../optimizations/mixins/locales'
import TaskOptimizationsChildMixin from '@/utils/crud/mixins/child-server'
// import TaskOptimizationsChildMixin from '@/utils/crud/mixins/child'
import ChildrenTable from '@/utils/crud/components/ChildrenTableServerMode.vue'
import ChildDetails from '@/utils/crud/components/ChildDetails.vue'

export default {
  mixins: [
    FieldsInfoMixin,
    LocalesMixin,
    TaskOptimizationsChildMixin,
  ],
  components: {
    'task-optimizations-table': ChildrenTable,
    'task-optimization-details': ChildDetails,
  },
  data () {
    return {
      resolverType: 'http',
      listRecords: 'listOpticheckOptimizations',
      getRecord: 'getOpticheckOptimization',
      createRecord: 'createOpticheckOptimization',
      updateRecord: 'updateOpticheckOptimization',
      deleteRecord: 'deleteOpticheckOptimization',
      pageTitle: 'opticheck.optimizations',
    }
  },
}
</script>
